// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#panel-info[data-v-963417d6] #navitime-copyright{display:flex;position:absolute;top:-22px;bottom:auto;transition:opacity .2s}#panel-info[data-v-963417d6] .gia-parts-scale{position:unset;line-height:8px;margin-right:7px}#panel-info[data-v-963417d6] .gia-parts-copyright-text{position:unset;line-height:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
